<template>
  <table
    data-testid="un-auth-sustainability-index-table"
    class="w-full table-fixed border-separate border-spacing-0 overflow-hidden rounded-xl"
    aria-describedby="table"
  >
    <thead data-testid="un-auth-sustainability-index-table-head">
      <tr class="text-base font-bold">
        <th />
        <th
          class="border-b border-r border-solid border-b-white border-r-white bg-[#8f0000] pb-9 pl-3 pt-2.5 text-left text-white"
        >
          Classification
        </th>
      </tr>
    </thead>
    <tbody data-testid="un-auth-sustainability-index-table-body">
      <tr v-for="(item, index) in items" :key="item.company" class="text-xs">
        <td
          class="border-b border-solid border-b-white pb-2 pl-3 pr-6 pt-2"
          :class="[index % 2 === 0 ? '' : 'bg-s-200']"
        >
          {{ item.company }}
        </td>
        <td
          class="border-b border-r border-solid border-b-white border-r-white pb-2 pl-16 pr-3 pt-2 text-end"
          :class="[index % 2 === 0 ? 'bg-s-50' : 'bg-s-200']"
        >
          {{ item.overall_index_performance }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
defineProps<{
  items: Array<{
    company: string
    overall_index_performance: string
  }>
}>()
</script>
